const FORWARD_URL_KEY = 'forwardUrl'

export const setForwardUrl = url => sessionStorage.setItem(FORWARD_URL_KEY, url)
export const getForwardUrl = () => sessionStorage.getItem(FORWARD_URL_KEY)
export const removeForwardUrl = () => sessionStorage.removeItem(FORWARD_URL_KEY)
